import { GridButtons } from "@/controls/buttons/GridButtons";
import { Guide } from "@/pages/catalogs/models/Guide";
import { optionsGuideCode } from "@/shared/selectors/GuideTypeSelector";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

type Props = {
	setSelectedRowData: (guide: Guide) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 3,
		},
		{
			field: "RFIDTag",
			headerName: "Tag",
			minWidth: 20,
			flex: 2,
		},
		{
			field: "LocationName",
			headerName: "Location",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "GuideTypeCode",
			headerName: "Type",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				optionsGuideCode.find(
					(code) => code.Code === (params.data as Guide).GuideTypeCode,
				)?.Name,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as Guide,
				setShowModal: setShowModal,
				edit: false,
				showContextMenu: () =>
					showContextMenu(event, params.data, "guideContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 2,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
